import React, { Component } from "react";
import { Switch, FormControlLabel } from "@material-ui/core";
import { languages } from "../../constants/languages";
import TeamsAsRefereesDialog from "../../components/teams/TeamsAsRefereesDialog";

class TeamsAsRefereesContainer extends Component {
  state = {
    showConfirmation: false,
  };

  handleSwitch = () => {
    let checked = !(this.props.tournament.teamsAsRefs || false);
    let toUpdate = {};
    toUpdate["teamsAsRefs"] = checked;

    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    batch.update(tournamentRef, toUpdate);
    const refereesRef = tournamentRef.collection("referees");
    if (checked) {
      this.props.allTeams.forEach((t) => {
        if (this.props.teams.find((r) => r.teamId === t.id) === undefined) {
          let newRefereeDoc = refereesRef.doc(t.id);
          let newReferee = { name: t.name, teamId: t.id, excludeTeams: [t.id] };
          batch.set(newRefereeDoc, newReferee);
        }
      });
    } else {
      this.props.allTeams.forEach((t) => {
        if (this.props.teams.find((r) => r.teamId === t.id) !== undefined) {
          const matchesRef = tournamentRef.collection("matches");

          matchesRef.get().then((querySnapshot) => {
            let batch2 = db.batch();
            batch2.delete(refereesRef.doc(t.id));

            querySnapshot.forEach((doc) => {
              if (doc.data().referee === t.id) {
                batch2.update(matchesRef.doc(doc.id), { referee: null });
              }
              if (doc.data().referee2 === t.id) {
                batch2.update(matchesRef.doc(doc.id), { referee2: null });
              }
              if (doc.data().referee3 === t.id) {
                batch2.update(matchesRef.doc(doc.id), { referee3: null });
              }
              if (doc.data().referee4 === t.id) {
                batch2.update(matchesRef.doc(doc.id), { referee4: null });
              }
              if (doc.data().referee5 === t.id) {
                batch2.update(matchesRef.doc(doc.id), { referee5: null });
              }
            });
            if (this.props.tournament.ia) {
              batch2.set(db.collection("cacheUpdatesApp").doc(), {
                tournamentId: this.props.tournament[".key"],
                status: "pending",
                timestamp:
                  window.firebase.firestore.FieldValue.serverTimestamp(),
              });
            }
            batch2.commit();
          });
        }
      });
    }
    batch.commit();
    this.toggleDialog();
  };

  toggleDialog = () => {
    this.setState({ showConfirmation: !this.state.showConfirmation });
  };

  render() {
    return (
      <div>
        <TeamsAsRefereesDialog
          tournament={this.props.tournament}
          open={this.state.showConfirmation}
          toggleDialog={this.toggleDialog}
          handleSwitch={this.handleSwitch}
        />
        <FormControlLabel
          control={
            <Switch
              checked={this.props.tournament.teamsAsRefs || false}
              onChange={(e) => {
                this.toggleDialog();
              }}
              color="primary"
              name="teamsAsRefs"
            />
          }
          label={languages.formatString(
            this.props.tournament.useJudges
              ? languages.referees.teamsAsJudges
              : languages.referees.teamsAsReferees,
            this.props.tournament.individualPlayers
              ? languages.teams.playersLow.charAt(0).toUpperCase() +
                  languages.teams.playersLow.slice(1)
              : languages.tournament.teamsLow.charAt(0).toUpperCase() +
                  languages.tournament.teamsLow.slice(1)
          )}
          style= {{ marginRight: 0 }}
        />
      </div>
    );
  }
}

export default TeamsAsRefereesContainer;
